import { convert } from '../utils'

let lines = [


  {text:['圣巴巴拉'],startTime:'00:00:01.00', endTime:'00:00:02.00'},
  {text:['是位于中央海岸地区的'],startTime:'00:00:02.01', endTime:'00:00:04.03'},
  {text:['一座浪漫小城'],startTime:'00:00:04.04', endTime:'00:00:06.03'},
  {text:['也是著名的美食天堂'],startTime:'00:00:06.04', endTime:'00:00:08.18'},
  {text:['市区内拥有超过400家餐厅'],startTime:'00:00:08.19', endTime:'00:00:11.15'},
  {text:['通常坐落在地中海风情的建筑里'],startTime:'00:00:11.16', endTime:'00:00:14.22'},
  {text:['这里保存着旧世界之美'],startTime:'00:00:14.23', endTime:'00:00:17.09'},
  {text:['素有“美国里维埃拉”之称'],startTime:'00:00:17.10', endTime:'00:00:20.10'},
  {text:['这里又焕发着新潮活力'],startTime:'00:00:20.11', endTime:'00:00:22.19'},
  {text:['除了美食'],startTime:'00:00:22.20', endTime:'00:00:23.21'},
  {text:['还有丰富多彩的艺术娱乐活动'],startTime:'00:00:23.22', endTime:'00:00:26.16'},
  {text:['是加州优质生活的典范'],startTime:'00:00:26.17', endTime:'00:00:29.11'},



]

export default convert(lines)
